module.exports = __webpack_public_path__ + "img/myqr-logo-vietqr@4x.04dd7063.png";